import { render, staticRenderFns } from "./ProjectProgress.vue?vue&type=template&id=2571221a&"
import script from "./ProjectProgress.vue?vue&type=script&lang=js&"
export * from "./ProjectProgress.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProgress.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports